import FormData from "form-data";
import axios from "axios";

export interface SendResponseEmail {
  email: string;
}

export const sendNotificationEmailRegistration = async (params: SendResponseEmail) => {
  const url = "https://ms-email.up.railway.app/welcome-email";
  const form = new FormData();
  form.append("ownerRef", "ArthurFortunato");
  form.append("emailFrom", "luiz.fortunatopicpay@gmail.com");
  form.append("emailTo", params.email);
  form.append("subject", "Boas-Vindas");
  try {
    const response = await axios.post(url, form, {
      headers: {
        ...form.getHeaders,
      },
    });
    console.log("Email successfully sent!");

    return response;
  } catch (error) {
    console.error("There was an error sending the email", error);
  }
};
